import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getAll,
    GetFieldsByCollectionPoint,
    GetDivisionByEstateID,
    GetPluckingAndSundryLabourChecklistReportData
};

async function GetFieldsByCollectionPoint(id) {
    var response = await CommonGet('/api/Field/GetFieldsByCollectionPointID', 'id=' + id);
    let array = [];
    for (let item of Object.entries(response.data)) {
        array[item[1]["fieldID"]] = item[1]["fieldName"];
    }
    return array;
}

async function getAll() {
    const response = await CommonGet('/api/OperationEntity/GetAllEstates', null);
    return response.data;
}

async function GetDivisionByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return divisionArray;
}

async function GetPluckingAndSundryLabourChecklistReportData(data) {
    let searchData = {
        groupID: parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        divisionID: data.divisionID,
        searchDate: data.searchDate,
        empType: parseInt(data.empType)
    }

    const response = await CommonPost('/api/PluckingAndSundryLabourChecklistReport/GetPluckingAndSundryLabourChecklistReportData', null, searchData);
    return response.data;
}

